const dictionary = {
  'properties.fluidity.splatVelocityScale': {
    max: 10,
    min: 0,
    step: 0.001,
  },
};

export default dictionary;
